import { render, staticRenderFns } from "./yesCollapse.vue?vue&type=template&id=03ea31fa"
import script from "./yesCollapse.vue?vue&type=script&lang=js"
export * from "./yesCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports